import { render, staticRenderFns } from "./IndustrySalary.vue?vue&type=template&id=72835bb4&scoped=true&"
import script from "./IndustrySalary.vue?vue&type=script&lang=js&"
export * from "./IndustrySalary.vue?vue&type=script&lang=js&"
import style0 from "./IndustrySalary.vue?vue&type=style&index=0&id=72835bb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72835bb4",
  null
  
)

export default component.exports